<h3 mat-dialog-title>{{userForm.value.id ?
  'Modifier':
'Créer'}} un utilisateur</h3>
<mat-dialog-content class="caaks-dialog-text">
  <div>Renseigner les informations suivantes.</div>
  <form [formGroup]="userForm">
    <mat-form-field>

      <input type="text" placeholder="Email de l'utilisateur" aria-label="Number" matInput formControlName="email"
        [matAutocomplete]="autoP">
      <mat-autocomplete #autoP="matAutocomplete" (optionSelected)="selectedUser($event.option.value)">
        @for (option of  filteredEmail|async; track option) {
          <mat-option [value]="option">
            {{option.email}}
          </mat-option>
        }
      </mat-autocomplete>
      @if (email!.hasError('uniqueName')) {
        <mat-error>
          Une ressource existe déjà avec ce nom.
        </mat-error>
      }
      @if (email?.hasError('email')) {
        L'email est mal formaté.
      }
      @if (email?.hasError('uniqueName')) {
        Un compte existe déjà avec cet email.
      }
      @if (email!.hasError('required')) {
        <mat-error> Le nom est requis. </mat-error>
      }
    </mat-form-field>

    <!--
    <mat-form-field>
      <input matInput formControlName="email" placeholder="email" required>
      <mat-error
        *ngIf="userForm.get('email')?.invalid && (userForm.get('email')?.dirty || userForm.get('email')?.touched)">
        <ng-container *ngIf="userForm.get('email')?.hasError('required')">
          L'email est requis.
        </ng-container>
        <ng-container *ngIf="userForm.get('email')?.hasError('email')">
          L'email est mal formaté.
        </ng-container>
        <ng-container *ngIf="userForm.get('email')?.hasError('uniqueName')">
          Un compte existe déjà avec cet email.
        </ng-container>
      </mat-error>
    </mat-form-field>
    -->
    <app-autocomplete formControlName="roles_list" [optionsDictionnary]="rolesListDictionary"
      [placeholder]="'Ajouter un rôle'" (optionSelected)="selectedOption($event)" (optionRemoved)="removeOption($event)"
    [displayProperty]="'name'" [valueProperty]="'name'"></app-autocomplete>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">

  <button mat-button color="primary" [disabled]="userForm.invalid" (click)="add()">
    <ng-template #processingProgress><mat-spinner [diameter]="10"></mat-spinner></ng-template>

    <span v-if="!processing">{{userForm.value.id ? 'Modifier':
    'Créer'}}</span></button>
    <button mat-button (click)="dialogRef.close()">Annuler</button>
  </mat-dialog-actions>